import { ChartType } from '@dbl/core/chart';

import type {
  IAnalysisEventLineChartResponseDto,
  IAnalysisEventLineChartResultVo,
  TAnalysisEventLineDataDto,
  TAnalysisEventLineDataVo,
} from '../types';

import {
  normalizeTableDataList,
  pickAxisChartWireVo,
  pickChartDisplayMeta,
} from './common';

/** EventLine · `event_list` 同形透传；`null`/非数组兜底 `[]`。 */
function normalizeEventLineData(
  value: TAnalysisEventLineDataDto | null | undefined,
): TAnalysisEventLineDataVo {
  if (!Array.isArray(value)) {
    return [];
  }

  return value.filter(
    item => item != null && typeof item === 'object',
  ) as TAnalysisEventLineDataVo;
}

export function transformEventLineChartResponseDtoToVo(
  dto: IAnalysisEventLineChartResponseDto,
): IAnalysisEventLineChartResultVo {
  const {
    event_line_chart: eventLineChartWire,
    event_list: eventDataWire,
    table_data: tableDataWire,
  } = dto;
  const { chartData: eventLineChart, isNoData } = pickAxisChartWireVo(
    eventLineChartWire,
  );

  return {
    ...pickChartDisplayMeta(dto),
    chartType: ChartType.EventLine,
    isNoData,
    /**
     * `isNoData === true` 时 omit 轴图 / 事件 / 表格 payload（不做 normalize），
     */
    ...(isNoData
      ? {}
      : {
          eventLineChart,
          eventData: normalizeEventLineData(eventDataWire),
          tableData: normalizeTableDataList(tableDataWire),
        }),
  };
}
